import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from './instance'

export default class MeasuringPoint {
  static async get(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/real_time_monitor/measuring_point/history/${payload.siteId}/${payload.startTime}/${payload.endTime}/${payload.points}`
      )
    )
    return Callback(err, res)
  }
  static async getHtData(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/real_time_monitor/measuring_point/real_time/${payload.siteId}/${payload.points}`
      )
    )
    return Callback(err, res)
  }
  static async getList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/MeasuringPoint?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async getFeedBackList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/real_time_monitor/measuring_point/feedback?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  static async findPointDetail(payload) {
    RecordOperation({ type: 'detail' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/real_time_monitor/measuring_point/pointId/${payload.pointId}`)
    )
    return Callback(err, res)
  }
}
